import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "utils/store";
import { GetDefaultCampaignPackagesResponse } from "./orderAd.api";
import { create } from "domain";
import { CampaignPackage, CampaignPackageType } from "./orderAd.entity";
import { stat } from "fs";

const selfSelect = (state: RootState) => state.orderAd;

type campaignDefaultPackagesSelectorType = (
  state: RootState
) => GetDefaultCampaignPackagesResponse | undefined;

export const campaignDefaultPackagesSelector: campaignDefaultPackagesSelectorType = createSelector(
  selfSelect,
  (state) => state.defaultPackagesInfo
);

type campaignDefaultPackageSelectorType = (
  type: CampaignPackageType
) => (state: RootState) => CampaignPackage | undefined;

export const campaignDefaultPackageSelector: campaignDefaultPackageSelectorType = (
  type: CampaignPackageType
) =>
  createSelector(selfSelect, (state) => {
    switch (type) {
      case CampaignPackageType.BASIC:
        return state.defaultPackagesInfo?.basic;
      case CampaignPackageType.ADVANCED:
        return state.defaultPackagesInfo?.advanced;
      case CampaignPackageType.BUSINESS:
        return state.defaultPackagesInfo?.business;
    }
  });
